import type { Availability } from '@packages/gql/generated/shopping/graphql';
import type { ClassAttributes, HTMLAttributes } from 'react';

export type AvailabilityInfoIndicatorProps = ClassAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    type: Availability['state'] | 'PLACEHOLDER';
  };

export const AvailabilityInfoIndicator = ({ type, ...props }: AvailabilityInfoIndicatorProps) => {
  if (type === 'UNSELECTED') {
    return <div {...props} className="icon-emp-info-filled h-3 w-3" />;
  }
  let typeClass = 'bg-color-success';
  if (type === 'NOT_AVAILABLE') {
    typeClass = 'bg-color-error';
  } else if (type === 'NOT_YET_AVAILABLE') {
    typeClass = 'bg-color-warning';
  } else if (type === 'PLACEHOLDER') {
    typeClass = 'opacity-0';
  }
  return <div {...props} className={`h-1.5 w-1.5 min-w-1.5 rounded-full ${typeClass} `} />;
};
